import { render } from "./Gallery.vue?vue&type=template&id=06e1099c"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Goya/components/Product/Gallery/Gallery.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06e1099c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06e1099c', __exports__)) {
    api.reload('06e1099c', __exports__)
  }
  
  module.hot.accept("./Gallery.vue?vue&type=template&id=06e1099c", () => {
    api.rerender('06e1099c', render)
  })

}


export default __exports__